export const environment = {
  production: false,
  accessKeyId: 'AKIAS66UCWX6NQKMCYNM',
  secretAccessKey: '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',
  firebaseConfig: {
    apiKey: "AIzaSyCXumwCgs35mvoqsXUWMF5pNUXDn0Sd1Zo",
    authDomain: "digital-iq--hub.firebaseapp.com",
    databaseURL: "https://digital-iq--hub-default-rtdb.firebaseio.com",
    projectId: "digital-iq--hub",
    storageBucket: "digital-iq--hub.firebasestorage.app",
    messagingSenderId: "533848362382",
    appId: "1:533848362382:web:c502e12e8078fbe43ee8df",
    measurementId: "G-2YV0KHMEK2"
  }
};
